module.exports = __webpack_public_path__ + "img/spider.9b38fd21.png";